import { useQuery } from '@tanstack/react-query';
import { apiClientV2 } from '~/api/client';
import { transformHydraResources } from '~/clientApi/hydra-utils';
import { SavedList } from '~/clientApi/savedLists.model';
import { SHARED_SAVED_LISTS } from '~/queries/keys';

interface Params {
  sharedToken?: string;
  initialData?: SavedList;
}

export const getSharedSavedListData = ({ sharedToken }: Params) =>
  apiClientV2
    .get(`/saved-lists`, {
      headers: { Authorization: `Bearer ${sharedToken}` },
    })
    .then((res) => transformHydraResources(res.data).results[0]);

export const useGetSharedSavedList = ({ sharedToken }: Params) =>
  useQuery<SavedList>({
    queryKey: [SHARED_SAVED_LISTS, { token: sharedToken }],
    queryFn: () => getSharedSavedListData({ sharedToken }),
    enabled: !!sharedToken,
    refetchOnMount: false,
    staleTime: 1000 * 60 * 5, // 5 minutes stale time to avoid inmediate fetching of cached data (initialData)
  });
